
      import '@webcomponents/scoped-custom-element-registry';
      import '@omicronenergy/oscd-shell/oscd-shell.js';
      import { plugins } from './plugins.js';

      const editor = document.querySelector('oscd-shell');
      editor.plugins = plugins;

      const params = new URL(document.location).searchParams;
      for (const [name, value] of params) {
        editor.setAttribute(name, value);
      }

      const filename = 'sample.scd';
      const sample = await fetch(filename).then(r => r.text());
      editor.docs = {
        [filename]: new DOMParser().parseFromString(sample, 'application/xml'),
      };
      editor.docName = filename;
    